import React, { useState, useEffect, useRef } from 'react'
import OurTheme from './OurTheme'
import get from 'lodash/get'
import set from 'lodash/set'
import size from 'lodash/size'
import cloneDeep from 'lodash/cloneDeep'
import each from 'lodash/each'
import isEmpty from 'lodash/isEmpty'
import strAllow from 'str-allow'
import { getNewMarker } from '../lib/helper'
import L from 'leaflet'
import { Container, Grid, Icon, Label, Dropdown, Header, Message, Button, TextArea, Checkbox, Radio, Form, Input, Card } from 'semantic-ui-react'

export default function MapForm(props) {
    // set initial customIcon (if any)
    let initialCustomIcon = {}
    const initialCustomIconUrl = get(window, 'webbymaps.data.mapData.config.markerIconsFileUrl')
    if (initialCustomIconUrl) {
        initialCustomIcon.url = initialCustomIconUrl
        initialCustomIcon.name = get(window, 'webbymaps.data.mapData.config.markerIconsFileName')
        initialCustomIcon.originalWidth = get(window, 'webbymaps.data.mapData.config.markerIconsFileOriginalWidth')
        initialCustomIcon.originalHeight = get(window, 'webbymaps.data.mapData.config.markerIconsFileOriginalHeight')
    }
    const [customIcon, setCustomIcon] = useState(initialCustomIcon)  // contain "blob", "url", "originalWidth", "originalHeight" properties

    const errorNotifications = get(props, 'errorNotifications')
    const pageName = get(window, 'webbymaps.data.page')

    // technique for differ between mount only & update only (https://stackoverflow.com/a/55075818)
    const isInitialMount = useRef(true)

    console.log('render MapForm')

    useEffect(() => { // "Effect" that is executed after setting up custom icon is done
        console.log('@useEffect-customIcon')
        if (isInitialMount.current) {
            // on initial mount only
            isInitialMount.current = false
            console.log('on initial mount')
        } else {
            // on update only (not executed on initial mounting)
            // this is when user upload a new custom icon
            console.log('on update (non-initial mount)')
            if (!isEmpty(customIcon)) {
                props.setMapData(latestMapData => {
                    const clonedMapData = cloneDeep(latestMapData)
                    const scaledHeight = Math.min(customIcon.originalHeight, 50)
                    let scaledWidth
                    if (customIcon.originalHeight > 50) {
                        const scale = customIcon.originalHeight / scaledHeight
                        scaledWidth = Math.round(customIcon.originalWidth / scale)
                    }
                    console.log(`scaledHeight:${scaledHeight}, width:${scaledWidth}`)
                    clonedMapData.config.markerIconsWidth = scaledWidth
                    clonedMapData.config.markerIconsHeight = scaledHeight
                    clonedMapData.config.markerIconsFile = get(customIcon, 'blob')
                    clonedMapData.config.markerIconsFileName = get(customIcon, 'blob.name')
                    return clonedMapData
                })
            }
        }
    }, [customIcon])


    const handleChangeInput = mapDataIdentifier => (evt, data) => {
        mapDataIdentifier = mapDataIdentifier.replace('mapData.', '')
        const newValue = evt.target.value
        props.setMapData(latestMapData => {
            const clonedMapData = cloneDeep(latestMapData)
            return set(clonedMapData, mapDataIdentifier, newValue)
        })
    }
    const handleChangeSelect = mapDataIdentifier => (evt, { value }) => {
        mapDataIdentifier = mapDataIdentifier.replace('mapData.', '')
        const newValue = value
        props.setMapData(latestMapData => {
            const clonedMapData = cloneDeep(latestMapData)
            return set(clonedMapData, mapDataIdentifier, newValue)
        })
    }
    const handleChangeToggle = mapDataIdentifier => (evt, { checked }) => {
        mapDataIdentifier = mapDataIdentifier.replace('mapData.', '')
        const newValue = checked
        props.setMapData(latestMapData => {
            const clonedMapData = cloneDeep(latestMapData)
            return set(clonedMapData, mapDataIdentifier, newValue)
        })
    }
    const handleChangeFileInput = mapDataIdentifier => (evt) => {
        mapDataIdentifier = mapDataIdentifier.replace('mapData.', '')
        const file = evt.target.files[0]
        const objectUrl = URL.createObjectURL(file)
        const img = new Image()
        img.onload = function () {
            const originalHeight = img.naturalHeight
            const originalWidth = img.naturalWidth

            setCustomIcon(latestCustomIcon => {
                if (customIcon) {
                    window.URL.revokeObjectURL(customIcon.blob)
                }
                const clonedCustomIcon = cloneDeep(latestCustomIcon)
                clonedCustomIcon.blob = file
                clonedCustomIcon.url = objectUrl
                clonedCustomIcon.name = file.name
                clonedCustomIcon.originalWidth = originalWidth
                clonedCustomIcon.originalHeight = originalHeight
                return clonedCustomIcon
            })
        }
        img.src = objectUrl
    }

    const handleSubmitForm = evt => {
        evt.preventDefault()
        // do something if necessary
        // ...
        evt.target.submit()
    }

    return (
        <Card fluid id='map-form'>
            <Card.Content>
                {!isEmpty(errorNotifications) &&
                    errorNotifications.map((itemNotification, n) =>
                        <Message key={n} negative>
                            <p>{itemNotification}</p>
                        </Message>)
                }

                <Form method="POST" action="" enctype="multipart/form-data" onSubmit={handleSubmitForm}>
                    {/* Map Name */}
                    <Form.Field>
                        <label>Map Name</label>
                        <Input name="mapName" required placeholder='Map Name' size="medium" defaultValue={get(props, 'mapData.name')} onBlur={handleChangeInput('mapData.name')} />
                    </Form.Field>

                    <Form.Field>
                        <label>Map Size</label>
                    </Form.Field>
                    <Form.Group inline>
                        <Form.Field width={1}>
                            <label className='weight-400'>Width</label>
                        </Form.Field>
                        <Form.Field width={2}>
                            <Input name="mapWidth" required className='width-input' type="number" min={0} defaultValue={get(props, 'mapData.config.width')} onBlur={handleChangeInput('mapData.config.width')} action={
                                <Dropdown button basic floating value={get(props, 'mapData.config.widthUnit', '%')} onChange={handleChangeSelect('mapData.config.widthUnit')} options={
                                    [
                                        { key: 'px', text: 'px', value: 'px' },
                                        { key: 'percent', text: '%', value: '%' }
                                    ]}
                                />}
                            />
                            <input name="mapWidthUnit" type="hidden" value={get(props, 'mapData.config.widthUnit', '%')}></input>
                        </Form.Field>
                    </Form.Group>
                    <Form.Group inline>
                        <Form.Field width={1}>
                            <label className='weight-400'>Height</label>
                        </Form.Field>

                        <Form.Field width={2}>
                            <Input name="mapHeight" required className='height-input' type="number" min={0} defaultValue={get(props, 'mapData.config.height')} onBlur={handleChangeInput('config.height')} action={
                                <Dropdown button basic floating value={get(props, 'mapData.config.heightUnit', 'px')} onChange={handleChangeSelect('config.heightUnit')} options={
                                    [
                                        { key: 'px', text: 'px', value: 'px' },
                                        { key: 'percent', text: '%', value: '%' }
                                    ]}
                                />}
                            />
                            <input name="mapHeightUnit" type="hidden" value={get(props, 'mapData.config.heightUnit', 'px')}></input>
                        </Form.Field>
                    </Form.Group>

                    <InfoWindowsFormSection handleChangeInput={handleChangeInput} handleChangeSelect={handleChangeSelect} handleChangeToggle={handleChangeToggle} {...props} />

                    <MarkersFormSection customIcon={customIcon} handleChangeInput={handleChangeInput} handleChangeSelect={handleChangeSelect} handleChangeToggle={handleChangeToggle} handleChangeFileInput={handleChangeFileInput} {...props} />

                    <Header size="tiny">Preview</Header>

                    <PreviewMap customIcon={customIcon} {...props} />

                    {/* <Button type='submit' primary size="small">Save Settings</Button> */}
                    <Button type="submit" id="btn-submit-map-form" primary size="small">{pageName === 'add-map' ? 'Create Map' : pageName === 'edit-map' ? 'Update Map' : 'Save Map'}</Button>
                </Form>
            </Card.Content>
        </Card>
    )
}

function InfoWindowsFormSection(props) {
    const isEnableInfoWindow = get(props, 'mapData.config.enableInfoWindows')
    return (
        <section id="infowindows-form">
            <Header size="tiny">Info Windows</Header>

            <Form.Field>
                <Checkbox name="enableInfoWindows" slider label={isEnableInfoWindow ? 'Info Windows Enabled' : 'Info Windows Disabled'} value="yes" defaultChecked={isEnableInfoWindow} onChange={props.handleChangeToggle('config.enableInfoWindows')} />
            </Form.Field>

            {isEnableInfoWindow &&
                <React.Fragment>
                    <Form.Group grouped>
                        <Form.Field>
                            <label className="weight-500">Type of Content</label>
                        </Form.Field>
                        <Form.Field>
                            <Radio name="infoWindowsContentType" checked={get(props, 'mapData.config.infoWindowsContentType') === 'default'} label="Default (Location Name & Address)" value="default" onChange={props.handleChangeSelect('mapData.config.infoWindowsContentType')} />
                        </Form.Field>
                        <Form.Field>
                            <Radio name="infoWindowsContentType" checked={get(props, 'mapData.config.infoWindowsContentType') === 'custom'} label="Custom HTML Content" value="custom" onChange={props.handleChangeSelect('mapData.config.infoWindowsContentType')} />
                        </Form.Field>
                    </Form.Group>

                    <Form.Group grouped>
                        <Form.Field>
                            <label className="weight-500">Show Info Windows</label>
                        </Form.Field>
                        <Form.Field>
                            <Radio name="showInfoWindowsOn" checked={get(props, 'mapData.config.showInfoWindowsOn') === 'start'} label="On start" value="start" onChange={props.handleChangeSelect('mapData.config.showInfoWindowsOn')} />
                        </Form.Field>
                        <Form.Field>
                            <Radio name="showInfoWindowsOn" checked={get(props, 'mapData.config.showInfoWindowsOn') === 'click'} label="When marker is clicked" value="click" onChange={props.handleChangeSelect('mapData.config.showInfoWindowsOn')} />
                        </Form.Field>
                    </Form.Group>

                    <Form.Group inline>
                        <Form.Field width={3}>
                            <label className='weight-500'>Additional Custom CSS Class (optional)</label>
                        </Form.Field>
                        <Form.Field>
                            <Input name="infoWindowsCustomClass" defaultValue={get(props, 'mapData.config.infoWindowsCustomClass')} onBlur={props.handleChangeInput('mapData.config.infoWindowsCustomClass')} />
                        </Form.Field>
                    </Form.Group>
                </React.Fragment>

            }
        </section>
    )
}

function MarkersFormSection(props) {
    const inputUploadFileRef = useRef()
    let markers = get(props, 'mapData.config.markers')
    const markerIconsType = get(props, 'mapData.config.markerIconsType')

    const customIconUrl = get(props, 'customIcon.url')

    const handleClickAddMarker = () => {
        props.setMapData(latestMapData => {
            const clonedMapData = cloneDeep(latestMapData)
            const newMarker = getNewMarker()
            clonedMapData.config.markers.push(newMarker)
            return clonedMapData
        })
    }

    const handleChangeIconSize = widthOrHeight => (evt, { value }) => {
        let newWidth = get(props, 'mapData.config.markerIconsWidth')
        let newHeight = get(props, 'mapData.config.markerIconsHeight')

        if (widthOrHeight === 'width') {
            newWidth = value
            if (!isEmpty(props.customIcon)) {
                const scale = get(props, 'customIcon.originalWidth') / newWidth
                newHeight = Math.round(parseInt(get(props, 'customIcon.originalHeight')) / scale)
            }

        } else if (widthOrHeight === 'height') {
            newHeight = value
            if (!isEmpty(props.customIcon)) {
                const scale = get(props, 'customIcon.originalHeight') / newHeight
                newWidth = Math.round(parseInt(get(props, 'customIcon.originalWidth')) / scale)
            }
        }

        props.setMapData(latestMapData => {
            const clonedMapData = cloneDeep(latestMapData)
            clonedMapData.config.markerIconsWidth = newWidth
            clonedMapData.config.markerIconsHeight = newHeight
            return clonedMapData
        })
    }

    const handleClickUploadFile = (evt, data) => {
        inputUploadFileRef.current.click()
    }

    return (
        <section id='markers-form'>
            <Header size="tiny">Markers</Header>

            <Form.Group grouped >
                <Form.Field>
                    <label className="weight-500">Icons</label>
                </Form.Field>
                <Form.Field>
                    <Radio name="markerIconsType" checked={markerIconsType === 'default'} label="Default Icon" value="default" onChange={props.handleChangeSelect('mapData.config.markerIconsType')} />
                </Form.Field>
                <Form.Field inline style={{ lineHeight: '40px' }}>
                    <Radio name="markerIconsType" checked={markerIconsType === 'custom'} label="Custom Icon" value="custom" onChange={props.handleChangeSelect('mapData.config.markerIconsType')} />
                    {markerIconsType === 'custom' &&
                        <React.Fragment>
                            <Button type="button" basic size="small" onClick={handleClickUploadFile} >Upload File</Button>
                            <p id="customicon-filename">{get(props, 'customIcon.name', '-')}</p>
                            <img id="customicon-preview" src={customIconUrl} />
                        </React.Fragment>
                    }

                    <input id="input-markerIconsFile" type="file" name="markerIconsFile" ref={inputUploadFileRef} accept=".png" onChange={props.handleChangeFileInput('mapData.config.markerIconsFile')} style={markerIconsType === 'default' ? { marginTop: 20 } : null} />
                    {/* <input id="input-markerIconsFile" type="file" name="markerIconsFile" ref={inputUploadFileRef} accept=".png" onChange={handleSelectFile} style={markerIconsType === 'default' ? { marginTop: 20 } : null} /> */}
                </Form.Field>
            </Form.Group>

            {markerIconsType === 'custom' && !isEmpty(props.customIcon) &&
                <Form.Group inline >
                    <Form.Field>
                        <label className="weight-500">Icon Size</label>
                    </Form.Field>
                    <Form.Field width={2}>
                        <Input name="markerIconsWidth" placeholder='Width' required={markerIconsType === 'custom'} type="number" min={1} label={{ basic: true, content: 'px' }} labelPosition='right' value={get(props, 'mapData.config.markerIconsWidth')} onChange={handleChangeIconSize('width')} size="small" />
                        {/* Original File Width */}
                        <input name="markerIconsFileOriginalWidth" type="hidden" value={get(props, 'customIcon.originalWidth')} />
                    </Form.Field>
                    <Form.Field width={2}>
                        <Input name="markerIconsHeight" placeholder='Height' required={markerIconsType === 'custom'} type="number" min={1} label={{ basic: true, content: 'px' }} labelPosition='right' value={get(props, 'mapData.config.markerIconsHeight')} onChange={handleChangeIconSize('height')} size="small" />
                        {/* Original File Height */}
                        <input name="markerIconsFileOriginalHeight" type="hidden" value={get(props, 'customIcon.originalHeight')} />
                    </Form.Field>
                </Form.Group>
            }


            {markers.map((marker, m) => <MarkerForm key={marker.id} index={m} markerId={marker.id} marker={marker} {...props} />)}
            <Button type="button" className='btn-add-marker' basic size="small" onClick={handleClickAddMarker}>Add another Marker</Button>
        </section>
    )
}

function MarkerForm(props) {
    const m = props.index
    const getMapDataIdentifier = markerIdentifier => `config.markers[${m}].${markerIdentifier}`

    const handleClickDeleteMarker = markerId => () => {
        props.setMapData(latestMapData => {
            let clonedMapData = cloneDeep(latestMapData)
            clonedMapData.config.markers = clonedMapData.config.markers.filter(item => item.id !== markerId)
            return clonedMapData
        })
    }

    const handleChangeMarkerLatlong = latlongType => (evt) => {
        const filterDecimal = strAllow('0123456789-.,')
        const inputValue = evt.target.value.toString().trim()
        const decimalString = filterDecimal(inputValue)
        const decimalCoordinate = parseFloat(decimalString)
        props.setMapData(latestMapData => {
            const mapDataIdentifier = getMapDataIdentifier(latlongType)
            const clonedMapData = cloneDeep(latestMapData)
            set(clonedMapData, mapDataIdentifier, isNaN(decimalCoordinate) ? decimalString : decimalCoordinate)
            return clonedMapData
        })
    }

    const handleValidateMarkerLatlong = latlongType => evt => {
        const value = get(props, getMapDataIdentifier(latlongType))
    }

    return (
        <Container className='marker-container'>
            <input name={`markerId[${m}]`} type="hidden" value={get(props, 'marker.id')} />
            <Form.Field>
                {/* <label>Marker #1</label> */}
                <Label size="large" tag content={`Marker #${m + 1}`} icon="map marker alternate" />
                {size(get(props, 'mapData.config.markers')) > 1 &&
                    <Button icon basic title='Delete' onClick={handleClickDeleteMarker(get(props, 'marker.id'))} >
                        <Icon name='trash alternate' color='red' />
                    </Button>
                }
            </Form.Field>

            <Form.Field>
                <label>Coordinate</label>
            </Form.Field>

            <Form.Group inline>
                <Form.Group grouped width={3} className="no-margin">
                    <Form.Field >
                        <Input name={`markerLatitude[${m}]`} label="Lat" placeholder='Latitude' required value={get(props, 'marker.latitude')} onChange={handleChangeMarkerLatlong('latitude')} onBlur={handleValidateMarkerLatlong('latitude')} size="small" />
                    </Form.Field>
                    <Form.Field>
                        <p className="description">(e.g., 37.744094)</p>
                    </Form.Field>
                </Form.Group>

                <Form.Group grouped width={3} className="no-margin">
                    <Form.Field>
                        <Input name={`markerLongitude[${m}]`} label="Long" placeholder='Longitude' required value={get(props, 'marker.longitude')} onChange={handleChangeMarkerLatlong('longitude')} size="small" />
                    </Form.Field>
                    <Form.Field>
                        <p className="description">(e.g., -122.421583)</p>
                    </Form.Field>
                </Form.Group>

            </Form.Group>

            {
                get(props, 'mapData.config.enableInfoWindows') &&
                <InfoWindowContentForm getMapDataIdentifier={getMapDataIdentifier} {...props} />
            }

        </Container >
    )
}

function InfoWindowContentForm(props) {
    const m = props.index
    return (
        <div className='infowindow-form'>
            <Form.Field>
                <label>Info Window Content</label>
            </Form.Field>

            {get(props, 'mapData.config.infoWindowsContentType') === 'default' &&
                <React.Fragment>
                    <Form.Group inline>
                        <Form.Field width={2}>
                            <label className='weight-500'>Location Name</label>
                        </Form.Field>
                        <Form.Field width={8}>
                            <Input name={`infoWindowLocationName[${m}]`} type="text" placeholder="Your Location" defaultValue={get(props, 'marker.infoWindowLocationName')} onBlur={props.handleChangeInput(props.getMapDataIdentifier('infoWindowLocationName'))} />
                        </Form.Field>
                    </Form.Group>

                    <Form.Group inline>
                        <Form.Field width={2}>
                            <label className='weight-500'>Location Address</label>
                        </Form.Field>
                        <Form.Field width={8}>
                            <input error name={`infoWindowLocationAddress[${m}]`} type="text" placeholder="Your Address and City" defaultValue={get(props, 'marker.infoWindowLocationAddress')} onBlur={props.handleChangeInput(props.getMapDataIdentifier('infoWindowLocationAddress'))} />
                        </Form.Field>
                    </Form.Group>

                    <Form.Group inline>
                        <Form.Field width={2}>
                            <label className='weight-500'>"Direction" Text</label>
                        </Form.Field>
                        <Form.Field width={8}>
                            <input name={`infoWindowDirectionText[${m}]`} type="text" placeholder='Direction' defaultValue={get(props, 'marker.infoWindowDirectionText')} onBlur={props.handleChangeInput(props.getMapDataIdentifier('infoWindowDirectionText'))} />
                        </Form.Field>
                    </Form.Group>
                </React.Fragment>
            }

            {get(props, 'mapData.config.infoWindowsContentType') === 'custom' &&
                <Form.Group inline>
                    <Form.Field width={2}>
                        <label className='weight-500'>Custom HTML Content</label>
                    </Form.Field>
                    <Form.Field width={8}>
                        <TextArea name={`infoWindowCustomContent[${m}]`} placeholder="Your custom info window content" defaultValue={get(props, 'marker.infoWindowCustomContent')} onBlur={props.handleChangeInput(props.getMapDataIdentifier('infoWindowCustomContent'))} />
                    </Form.Field>
                </Form.Group>
            }
        </div>
    )
}

function PreviewMap(props) {
    const previewMapRef = useRef()

    useEffect(() => {
        var map = L.map(previewMapRef.current, {
            attributionControl: true,
            scrollWheelZoom: false
        })
        // .setView([-7.440601, 110.220512], 13)
        // .setView([51.505, -0.09], 13);

        const markers = get(props, 'mapData.config.markers')

        const markerCoordinates = []
        each(markers, markerData => {
            const latitude = get(markerData, 'latitude')
            const longitude = get(markerData, 'longitude')
            if (!!latitude && !!longitude && !isNaN(latitude) && !isNaN(longitude)) {
                markerCoordinates.push({ lat: latitude, lng: longitude })
            }
        })
        if (!isEmpty(markerCoordinates)) {
            const markerBounds = L.latLngBounds(markerCoordinates)
            map.fitBounds(markerBounds)
            const zoom = map.getZoom()
            // map.panBy([0, -300])
            map.setZoom(zoom - 1)

        }

        // remove "Leaflet" attribution
        map.attributionControl.setPrefix('WebbyMaps')

        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            // attribution: attribution
        }).addTo(map);

        const markerIconsType = get(props, 'mapData.config.markerIconsType')
        const markerIconsWidth = get(props, 'mapData.config.markerIconsWidth')
        const markerIconsHeight = get(props, 'mapData.config.markerIconsHeight')
        const customIconUrl = get(props, 'customIcon.url')
        const enableInfoWindows = get(props, 'mapData.config.enableInfoWindows')
        const infoWindowsContentType = get(props, 'mapData.config.infoWindowsContentType')
        const showInfoWindowsOn = get(props, 'mapData.config.showInfoWindowsOn')
        const infoWindowsCustomClass = get(props, 'mapData.config.infoWindowsCustomClass')

        markers.map((markerData, m) => {
            const latitude = get(markerData, 'latitude')
            const longitude = get(markerData, 'longitude')
            if (!!latitude && !!longitude && !isNaN(latitude) && !isNaN(longitude)) {
                const marker = L.marker({ lat: markerData.latitude, lng: markerData.longitude })
                    .addTo(map)

                if (markerIconsType === 'custom' && customIconUrl && markerIconsWidth && markerIconsHeight) {
                    const icon = L.icon({
                        iconUrl: customIconUrl,
                        iconSize: [markerIconsWidth, markerIconsHeight], // size of the icon
                        iconAnchor: [markerIconsWidth / 2, markerIconsHeight], // point of the icon which will correspond to marker's location // iconAnchor dihitung dari 0,0 atas kiri
                        popupAnchor: [0, markerIconsHeight * (-1)] // point from which the popup should open relative to the iconAnchor
                        // iconSize: [38, 95], // size of the icon
                        // iconAnchor: [22, 94], // point of the icon which will correspond to marker's location // iconAnchor dihitung dari 0,0 atas kiri
                        // popupAnchor: [-3, -76] // point from which the popup should open relative to the iconAnchor
                    })
                    marker.setIcon(icon)
                }

                if (enableInfoWindows) {
                    let infoWindowContent

                    if (infoWindowsContentType === 'default') {
                        const infoWindowLocationName = !!markerData.infoWindowLocationName ? markerData.infoWindowLocationName : 'Your Location'
                        const infoWindowLocationAddress = !!markerData.infoWindowLocationAddress ? markerData.infoWindowLocationAddress : 'Your Address and City'
                        const directionText = !!markerData.infoWindowDirectionText ? markerData.infoWindowDirectionText : 'Direction'
                        const directionLink = `https://www.google.com/maps/dir/?api=1&destination=${latitude},${longitude}`
                        infoWindowContent = `<b>${infoWindowLocationName}</b><p>${infoWindowLocationAddress}</p><a href="${directionLink}" target="_blank"><b>&#8618;</b> ${directionText}</a>`
                    } else if (infoWindowsContentType === 'custom') {
                        const infoWindowCustomContent = get(markerData, 'infoWindowCustomContent')
                        infoWindowContent = isEmpty(infoWindowCustomContent) ? 'Your custom info window content' : infoWindowCustomContent
                    }

                    marker.bindPopup(infoWindowContent, {
                        maxWidth: 275,
                        autoClose: false,
                        closeOnClick: false,
                        className: infoWindowsCustomClass
                    })
                }
                if (enableInfoWindows && showInfoWindowsOn === 'start') {
                    marker.openPopup()
                }
            }

        })

        return function cleanUp() {
            map.remove()
        }
    }, [JSON.stringify(props.mapData)])

    return (
        <div id="preview-map" style={{ height: `${get(props, 'mapData.config.height')}${get(props, 'mapData.config.heightUnit')}`, width: `${get(props, 'mapData.config.width')}${get(props, 'mapData.config.widthUnit')}` }} ref={previewMapRef}>

        </div>
    )
}